export const modeAccentBorderClass = (mode) => mode === "live"
    ? "border-l-4 border-l-rose-500 dark:border-l-rose-400"
    : "border-l-4 border-l-sky-500 dark:border-l-sky-400";
export const modePanelTintClass = (mode) => mode === "live"
    ? "bg-rose-50/60 dark:bg-rose-950/20"
    : "bg-sky-50/60 dark:bg-sky-950/20";
